import React from 'react';
import { Moon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-navy border-t border-white/10 py-12 text-center" data-id="element-26">
      <div className="max-w-4xl mx-auto px-6" data-id="element-27">
        <div className="flex justify-center mb-6" data-id="element-28">
          <Moon className="w-8 h-8 text-amber/50" data-id="element-29" />
        </div>
        <p className="text-cream/50 text-sm mb-4" data-id="element-30">
          © {new Date().getFullYear()} Dulces Sueños. Todos los derechos
          reservados.
        </p>
        <p className="text-cream/30 text-xs max-w-2xl mx-auto" data-id="element-31">
          Este producto no sustituye el consejo médico profesional. Si tienes
          preocupaciones sobre la salud de tu bebé, consulta siempre a tu
          pediatra.
        </p>
      </div>
    </footer>;
}